// @flow

export default (schema: Object, t: Function, enableBV12: boolean) => {
  let oneOf = [...(schema || {}).properties.trendType.oneOf];
  let daysOptStart = 2;
  if (enableBV12) {
    daysOptStart = 6;
    oneOf.splice(
      1,
      0,
      {
        title: t("BV12_FTE_AVAILABLE"),
        const: "BV12_FTE_AVAILABLE",
      },
      {
        title: t("BV12_SCORE"),
        const: "BV12_SCORE",
      },
    );
  }

  oneOf.splice(daysOptStart, 0, {
    title: t("DAYS_AVAILABLE"),
    const: "DAYS_AVAILABLE",
  });

  return {
    ...schema,
    properties: {
      ...(schema || {}).properties,
      trendType: {
        ...(schema || {}).properties.trendType,
        oneOf,
      },
    },
  };
};
